<template>
  <div class="page-login">
    <div class="page-login--layer page-login--layer-area">
      <ul class="circles">
        <li v-for="n in 10" :key="n"></li>
      </ul>
    </div>
    <!-- <div class="page-login--layer page-login--layer-time" flex="main:center cross:center">{{time}}</div> -->
    <div class="page-login--layer">
      <div
        class="page-login--content"
        flex="dir:top main:justify cross:stretch box:justify"
      >
        <div class="page-login--content-header">
          <!-- <p class="page-login--content-header-motto">时间是一切财富中最宝贵的财富</p> -->
        </div>
        <div
          class="page-login--content-main"
          flex="dir:top main:center cross:center"
        >
          <!-- logo -->
          <!-- <img
            class="page-login--logo"
            src="http://abs-qa.xiaozipu.cn/image/theme/abs/logo/all.png"
          />-->
          <!-- form -->
          <div class="page-login--form">
            <el-card body-style="padding: 0;" class="overflow-hidden">
              <el-row>
                <el-col>
                  <div class="page-login--form--main">
                    <center>
                      <!-- <img src="../../../../public/image/theme/default/logo.png" /> -->
                      <img src="./images/logo.png" />
                    </center>
                    <el-form @keyup.enter.native="submit">
                      <div class="mb-4">
                        <el-input
                          clearable
                          :placeholder="
                            $l('login_tips_user') || '请输入登录账号'
                          "
                          v-model="formLogin.account"
                        >
                          <span slot="prepend">
                            <i class="fa fa-user-circle-o"></i>
                          </span>
                        </el-input>
                      </div>
                      <div class="mb-4">
                        <el-input
                          type="password"
                          clearable
                          show-password
                          :placeholder="
                            $l('login_tips_pwd') || '请输入登录密码'
                          "
                          v-model="formLogin.password"
                        >
                          <span slot="prepend">
                            <i class="fa fa-keyboard-o"></i>
                          </span>
                        </el-input>
                      </div>
                      <el-row class="mb-4">
                        <!-- <el-col cols="auto">
                          <el-checkbox>记住我</el-checkbox>
                        </el-col> -->
                        <el-col class="d-flex justify-content-end">
                          <el-dropdown @command="changeLocale">
                            <span class="el-dropdown-link">
                              <i class="fa fa-language" aria-hidden="true"></i>
                              {{ language.label }}
                              <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item
                                v-for="language in languages"
                                :key="language.value"
                                :command="language"
                              >
                                {{ language.label }}
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </el-col>
                      </el-row>
                      <el-button
                        type="success"
                        style="width: 100%"
                        @click="submit"
                        >{{ $l('login_btn') || '确定' }}</el-button
                      >
                    </el-form>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </div>
        <div class="page-login--content-footer">
          <p class="page-login--content-footer-copyright">
            <!-- Copyright -->
            <!-- <i class="fa fa-copyright" aria-hidden="true"></i> -->
            <a href="https://beian.miit.gov.cn" target="_blank"
              ><span
                >{{
                  $l('login_company_name') || '地平线控股（苏州）股份有限公司'
                }}
                &nbsp;版权所有</span
              ></a
            >&nbsp;&nbsp;
            <a href="https://beian.miit.gov.cn" target="_blank"
              ><span>{{
                $l('login_company_icp') || '苏ICP备20023929号-2'
              }}</span></a
            >
          </p>
          <!-- <p class="page-login--content-footer-options">
            <a href="#">帮助</a>
            <a href="#">隐私</a>
            <a href="#">条款</a>
          </p>-->
        </div>
      </div>
    </div>

    <RestPasswordDialog
      :visible.sync="dialogFormVisible"
      :userCode="userCode"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import localeMixin from '@/locales/mixin.js'
import RestPasswordDialog from '@/components/resetpassword/dialog'
export default {
  components: { RestPasswordDialog },
  mixins: [localeMixin],
  data() {
    return {
      dialogFormVisible: false,
      userCode: '',
      // 表单
      formLogin: {
        account: '',
        password: '',
        appName: 'pla',
      },
      // 表单校验
      rules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/system', ['languages', 'language']),
  },
  created() {
    this.languagesLoad()
  },
  methods: {
    ...mapActions('admin/account', ['login']),
    ...mapActions('admin/system', [
      'languagesLoad',
      'versionLoad',
      'checkVersion',
    ]),
    submit() {
      this.login(this.formLogin).then((res) => {
        const { status, body } = res
        if (status === 10001) {
          this.dialogFormVisible = true
          this.userCode = body
          return
        }
        this.$router.replace(this.$route.query.redirect || '/')
        this.versionLoad()
      })
    },
    changeLocale(val) {
      this.onChangeLocale(val)
      location.reload()
    },
  },
}
</script>

<style lang="scss">
.page-login {
  @extend %unable-select;
  $backgroundColor: #f0f2f5;
  // ---
  background-color: $backgroundColor;
  background-image: url(./images/background.jpg);
  background-size: cover;
  height: 100%;
  position: relative;
  // 层
  .page-login--layer {
    @extend %full;
    overflow: auto;
  }
  .page-login--layer-area {
    overflow: hidden;
  }
  // 时间
  .page-login--layer-time {
    font-size: 24em;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.03);
    overflow: hidden;
  }
  // 登陆页面控件的容器
  .page-login--content {
    height: 100%;
    min-height: 500px;
  }
  // header
  .page-login--content-header {
    padding: 1em 0;
    .page-login--content-header-motto {
      margin: 0px;
      padding: 0px;
      color: $color-text-normal;
      text-align: center;
      font-size: 12px;
    }
  }
  // main
  .page-login--logo {
    width: 240px;
    margin-bottom: 2em;
    margin-top: -2em;
  }
  // 登录表单
  .page-login--form {
    min-width: 380px;
    position: absolute;
    right: 20%;
    .page-login--form--main {
      // height: 300px;
      padding: 20px;
    }
    // 卡片
    .el-card {
      margin-bottom: 15px;
    }
    // 登录按钮
    .button-login {
      width: 100%;
    }
    // 输入框左边的图表区域缩窄
    .el-input-group__prepend {
      padding: 0px 14px;
    }
    .login-code {
      height: 40px - 2px;
      display: block;
      margin: 0px -20px;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
    // 登陆选项
    .page-login--options {
      margin: 0px;
      padding: 0px;
      font-size: 14px;
      color: $color-primary;
      margin-bottom: 15px;
      font-weight: bold;
    }
    .page-login--quick {
      width: 100%;
    }
  }
  // 快速选择用户面板
  .page-login--quick-user {
    @extend %flex-center-col;
    padding: 10px 0px;
    border-radius: 4px;
    &:hover {
      background-color: $color-bg;
      i {
        color: $color-text-normal;
      }
      span {
        color: $color-text-normal;
      }
    }
    i {
      font-size: 36px;
      color: $color-text-sub;
    }
    span {
      font-size: 12px;
      margin-top: 10px;
      color: $color-text-sub;
    }
  }
  // footer
  .page-login--content-footer {
    padding: 1em 0;
    .page-login--content-footer-locales {
      padding: 0px;
      margin: 0px;
      margin-bottom: 15px;
      font-size: 12px;
      line-height: 12px;
      text-align: center;
      color: $color-text-normal;
      a {
        color: $color-text-normal;
        margin: 0 0.5em;
        &:hover {
          color: $color-text-main;
        }
      }
    }
    .page-login--content-footer-copyright {
      padding: 0px;
      margin: 0px;
      margin-bottom: 10px;
      font-size: 12px;
      line-height: 12px;
      text-align: center;
      color: $color-text-normal;
      a {
        color: $color-text-normal;
      }
    }
    .page-login--content-footer-options {
      padding: 0px;
      margin: 0px;
      font-size: 12px;
      line-height: 12px;
      text-align: center;
      a {
        color: $color-text-normal;
        margin: 0 1em;
      }
    }
  }
  // 背景
  .circles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin: 0px;
    padding: 0px;
    li {
      position: absolute;
      display: block;
      list-style: none;
      width: 20px;
      height: 20px;
      background: #fff;
      animation: animate 25s linear infinite;
      bottom: -200px;
      @keyframes animate {
        0% {
          transform: translateY(0) rotate(0deg);
          opacity: 1;
          border-radius: 0;
        }
        100% {
          transform: translateY(-1000px) rotate(720deg);
          opacity: 0;
          border-radius: 50%;
        }
      }
      &:nth-child(1) {
        left: 15%;
        width: 80px;
        height: 80px;
        animation-delay: 0s;
      }
      &:nth-child(2) {
        left: 5%;
        width: 20px;
        height: 20px;
        animation-delay: 2s;
        animation-duration: 12s;
      }
      &:nth-child(3) {
        left: 70%;
        width: 20px;
        height: 20px;
        animation-delay: 4s;
      }
      &:nth-child(4) {
        left: 40%;
        width: 60px;
        height: 60px;
        animation-delay: 0s;
        animation-duration: 18s;
      }
      &:nth-child(5) {
        left: 65%;
        width: 20px;
        height: 20px;
        animation-delay: 0s;
      }
      &:nth-child(6) {
        left: 75%;
        width: 150px;
        height: 150px;
        animation-delay: 3s;
      }
      &:nth-child(7) {
        left: 35%;
        width: 200px;
        height: 200px;
        animation-delay: 7s;
      }
      &:nth-child(8) {
        left: 50%;
        width: 25px;
        height: 25px;
        animation-delay: 15s;
        animation-duration: 45s;
      }
      &:nth-child(9) {
        left: 20%;
        width: 15px;
        height: 15px;
        animation-delay: 2s;
        animation-duration: 35s;
      }
      &:nth-child(10) {
        left: 85%;
        width: 150px;
        height: 150px;
        animation-delay: 0s;
        animation-duration: 11s;
      }
    }
  }
}
</style>
